import { TextField } from "@mui/material";
import React from "react";
import GlobalStoreContext from "../../../../context/GlobalStoreContext";
import { Team } from "../../../../models/Team";
import AddTeamGeocoder from "../../../Search/AddTeamGeocoder";

interface Props {
    selectedTeam: Team;
    setSelectedTeam: (team: Team) => void;
    vendorMode?: boolean;
}

const CreateFields: React.FC<Props> = (props) => {
    const context = React.useContext(GlobalStoreContext);

    return (
        <div className="w-full shadow-md rounded-2xl p-5 flex flex-col gap-2">
            <div className="px-2">
                <TextField
                    className="w-full"
                    value={props.selectedTeam.teamName}
                    onChange={(e) => {
                        const newSelectedTeam = Object.create(props.selectedTeam) as Team;

                        newSelectedTeam.teamName = e.target.value;

                        props.setSelectedTeam(Object.create(newSelectedTeam) as Team);
                    }}
                    label={`New ${props.vendorMode ? "Vendor" : "Company"} Name:`}
                />
            </div>

            <div className="px-2 mt-2">
                <div className="flex">
                    <div>Company Address</div>
                    {props.vendorMode &&
                        context.currentProjectInfo.require_vendor_address &&
                        !props.selectedTeam.address1 && (
                            <div className="text-plot-leadtime ml-1 text-xs">*An address is required for vendors</div>
                        )}
                </div>
                <AddTeamGeocoder
                    updateAddress={(result) => {
                        const newSelectedTeam = Object.create(props.selectedTeam) as Team;

                        newSelectedTeam.address1 = result.team.address_1;
                        newSelectedTeam.address2 = result.team.address_2;
                        newSelectedTeam.city = result.team.city;
                        newSelectedTeam.state = result.team.state;
                        newSelectedTeam.zipCode = result.team.zip_code;
                        newSelectedTeam.lat = result.team.lat;
                        newSelectedTeam.lon = result.team.lon;

                        props.setSelectedTeam(newSelectedTeam);
                    }}
                    placeholder={`Search for ${props.selectedTeam.teamName}'s address`}
                    onClear={() => {
                        const newSelectedTeam = Object.create(props.selectedTeam) as Team;

                        newSelectedTeam.address1 = null;
                        newSelectedTeam.address2 = null;
                        newSelectedTeam.city = null;
                        newSelectedTeam.state = null;
                        newSelectedTeam.zipCode = null;
                        newSelectedTeam.lat = null;
                        newSelectedTeam.lon = null;

                        props.setSelectedTeam(newSelectedTeam);
                    }}
                />
            </div>
        </div>
    );
};

export default CreateFields;
